import script from "./notifications-container.vue?vue&type=script&setup=true&lang=ts"
export * from "./notifications-container.vue?vue&type=script&setup=true&lang=ts"

import "./notifications-container.vue?vue&type=style&index=0&id=2c5314e2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c5314e2"]])

export default __exports__